const RD_CONSENT_EVENTS = ['rd_cookie_consent_allow_analytics', 'rd_cookie_consent_allow_functional'] as const;

const RD_BANNER_STATUS_COOKIES = ['cookieconsent_status_ANALYTICS', 'cookieconsent_status_PERSONALIZATION'];

type EventTarget = Pick<Document, 'dispatchEvent'>;
type CookieTarget = Pick<Document, 'cookie'> & { location: Pick<Location, 'host'> };

// RD Station only starts lead tracking after these events, which its own cookie banner normally fires.
// That banner is hidden here (see app/globals.css), so the storefront banner has to fire them instead.
export function grantRDStationConsent(target: EventTarget = document) {
  RD_CONSENT_EVENTS.forEach((eventName) => target.dispatchEvent(new Event(eventName)));
}

// An answer given earlier on RD's own banner is stored in these cookies and would let RD track again
// on its next load, overriding the choice made in the storefront banner.
export function clearRDStationBannerChoice(target: CookieTarget = document) {
  RD_BANNER_STATUS_COOKIES.forEach((name) => {
    const expired = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
    target.cookie = expired;
    target.cookie = `${expired};domain=${target.location.host}`;
  });
}
